<template>
  <div>
    <ca-heading text="Informações do contrato" size="medium"></ca-heading>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Data de admissão">
          {{ contractInfo.admissionDate | caDate }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Tipo de contrato de trabalho">
          {{ contractInfo.contractType.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Tipo de admissão">
          {{ contractInfo.admissionType.description }}
        </ca-field>
      </ca-col>
      <ca-col v-if="contractInfo.contractType.value == '3'" size="4">
        <ca-field label="Qtd. de dias Experiência">
          {{ contractInfo.contractDaysExperience }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col v-if="contractInfo.contractType.value == '3'" size="4">
        <ca-field label="Qtd. de dias Prorrogação">
          {{ contractInfo.contractExtensionDays }}
        </ca-field>
      </ca-col>
      <ca-col v-if="contractInfo.contractType.value != '1'" size="4">
        <ca-field label="Data do término do contrato">
          {{ contractInfo.contractEndDate }}
        </ca-field>
      </ca-col>
      <ca-col v-if="contractInfo.contractType.value == '3'" size="4">
        <ca-field label="Tipo de admissão">
          {{ contractInfo.admissionIndicator.description }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Indicativo de admissão">
          {{ contractInfo.admissionIndicator.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Unidade de salário">
          {{ contractInfo.salaryUnit.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Salário">
          R$ {{ contractInfo.salary | caCurrency }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Calcular Contribuição Sindical">
          {{ contractInfo.unionContribution ? 'Sim' : 'Não' }}
        </ca-field>
      </ca-col>

      <ca-col size="4">
        <ca-field label="Calcular DSR">
          {{ contractInfo.dsr ? 'Sim' : 'Não' }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Recebe FGTS">
          {{ contractInfo.fgts ? 'Sim' : 'Não' }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row v-if="contractInfo.temporary">
      <ca-col size="4">
        <ca-field label="Hipótese Legal para Contratação">
          {{ contractInfo.temporaryLegalType.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Justificação da Hipótese Legal">
          {{ contractInfo.temporaryJustification }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Tipo de Inclusão de Contrato">
          {{ contractInfo.temporaryInclusion.description }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row v-if="contractInfo.temporary">
      <ca-col size="4">
        <ca-field label="CPF do Trabalhador Substituído">
          {{ contractInfo.temporaryCpfReplaced | caCpf }}
        </ca-field>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>

export default {
  name: 'WorkerContractInfo',
  props: {
    contractInfo: Object,
    worker: Object,
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'FormPage' });
    },
    onEdit() {
      this.$router.push({
        name: 'WorkerContractInfoForm',
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>
